import { FC, useEffect, useState } from "react";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/grid";

import ArrowSvg from "@/public/icon/arrow";
import { Card, List } from "antd";
interface SectionProps {
  isMobile: boolean;
  isPad: boolean;
  list?: string[];
}

const partnerList = [
  {
    icon: "",
    desc: "中国电信是中国特大型通信运营企业，主要经营移动通信、互联网接入及应用、固定电话、卫星通信、ICT集成等综合信息服务。",
    title: "中国电信",
  },
  {
    icon: "",
    desc: "中国移动是按照国家电信体制改革的总体部署，于2000年组建成立的中央企业，是中国特大型通信运营企业。",
    title: "中国移动",
  },
  {
    icon: "",
    desc: "浙江省教育技术中心围绕全省教育改革和发展的大局，不断推进教育技术发展、服务教育现代化建设。",
    title: "浙江省教育技术中心",
  },
];

const baseImgPath = "/home/partner";
const CardList: FC<Partial<SectionProps>> = ({ isPad, list }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<string[]>([]);

  useEffect(() => {
    setData(list!.slice(0, 8));
  }, [list]);

  const handleLoadMore = () => {
    setLoading(true);
    const dLen = data.length,
      lLen = list!.length;

    setTimeout(() => {
      setData([...data, ...list!.slice(dLen, Math.min(dLen + 8, lLen))]);
      setLoading(false);
    }, 1000);
  };

  return (
    <List
      grid={{ column: isPad ? 4 : 3, gutter: 10 }}
      dataSource={data}
      loading={loading}
      loadMore={
        !loading && data.length < list!.length ? (
          <div
            style={{
              textAlign: "center",
              marginTop: 4,
            }}
            className="text-[#004EA2]"
          >
            <p className="cursor-pointer" onClick={handleLoadMore}>
              查看更多
            </p>
          </div>
        ) : null
      }
      renderItem={(item, idx) => {
        return (
          <List.Item
            className="bg-white !p-3 h-14 sm:h-16 flex-col items-center !flex rounded-lg
            shadow-[4px_4px_8px_0px_rgba(0,0,0,0.1)]"
            key={idx}
          >
            <Image
              className="w-full h-full"
              src={item}
              alt="partner"
              width="120"
              height="34"
              quality={100}
            />
          </List.Item>
        );
      }}
    />
  );
};

export const Section6: FC<SectionProps> = ({ isMobile, isPad }) => {
  const [list, setList] = useState<string[]>([]);
  const [swiperList, setSwiperList] = useState<string[][]>([]);

  const pathToName = (path: string) => {
    const reg = /\/([^/]+)\.(.*)$/;
    const match = path.match(reg);
    return match ? match[1] : "";
  };
  useEffect(() => {
    const imagesContext = require.context(
      "!file-loader!../public/home/partner",
      false,
      /\.(png|jpe?g|svg)$/
    );
    const res = imagesContext
      .keys()
      .filter((c) => c.startsWith("."))
      .sort((a: string, b: string) => +pathToName(a) - +pathToName(b))
      .map((c) => baseImgPath + c.slice(1));

    setList(res.slice());
    setSwiperList(transformList(res.slice(3)));
  }, []);

  const transformList = (list: string[]) => {
    const res: string[][] = [];
    return list.reduce((acc, cur, idx) => {
      if (idx % 2 === 0) {
        acc.push([cur]);
      } else {
        acc[acc.length - 1].push(cur);
      }
      return res;
    }, res);
  };

  return (
    <>
      <div className="container  md:pt-20 md:pb-14 md:px-0 p-6 pt-10">
        <h3 className="text-[#333333] text-lg md:text-3xl text-center">
          合作伙伴及案例
        </h3>
        <h5 className="text-[#999999] text-xs md:text-base mt-4 text-center mb-5 md:mb-12">
          面向政府、金融、能源、运营商、互联网、大型企业等
        </h5>

        {isMobile ? (
          <CardList isPad={isPad} list={list.slice(3)} />
        ) : (
          <>
            <div className="flex space-x-4 mb-7">
              {list.slice(0, 3).map((item, idx) => (
                <div
                  key={idx}
                  className="w-full border border-[#F2F2F2] px-7 py-[1.375rem] rounded-lg flex flex-col items-start bg-white 
                  hover:shadow-[7px_7px_12px_0px_rgba(0,26,55,0.08)]
                  "
                >
                  <p className="w-30 h-[34px]">
                    <Image
                      src={item}
                      className="block w-full h-full"
                      alt="partner"
                      width="240"
                      height="34"
                      quality={100}
                    />
                  </p>
                  <p className="text-sm leading-5 text-[#333333] overflow-hidden text-ellipsis line-clamp-2 mt-7">
                    {partnerList[idx].desc}
                  </p>
                  <p className="w-full flex items-end flex-row justify-end text-[#333333] text-sm mt-[1.25rem]">
                    —{partnerList[idx].title}
                  </p>
                </div>
              ))}
            </div>

            <div className="relative">
              <Swiper
                modules={[Autoplay]}
                className="swiper mySwiper"
                spaceBetween={20}
                loop={true}
                slidesPerView={5}
                autoplay={{
                  delay: 2000,
                  stopOnLastSlide: false,
                  disableOnInteraction: false,
                }}
              >
                <div className="swiper-wrapper grid-cols-[100%]">
                  {swiperList.map((items, lIdx) => (
                    <SwiperSlide
                      key={lIdx}
                      className="bg-transparent flex-center !flex flex-col space-y-5"
                    >
                      {items.map((item, idx) => (
                        <div
                          key={idx}
                          className="w-full bg-white py-4 rounded-lg
                          flex-center
                          border hover:border-[#F2F2F2]
                          hover:shadow-[3px_3px_12px_0px_rgba(0,77,161,0.12)]"
                        >
                          <Image
                            src={item}
                            alt="partner"
                            width="164"
                            height="54"
                            quality={100}
                          />
                        </div>
                      ))}
                    </SwiperSlide>
                  ))}
                </div>
              </Swiper>
              {/* <div className="swiper-button-next translate-y-6 after:!content-[''] !right-[-50px]">
                <ArrowSvg fill="#004DA1" color="#004DA1" className="w-6 h-6" />
                  </div>
                  <div className="swiper-button-prev translate-y-6 after:!content-[''] !left-[-50px]">
                    <ArrowSvg
                      fill="#004DA1"
                      color="#004DA1"
                      className="w-6 h-6 rotate-180"
                    />
              </div> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};
